import { ajax } from "@/config/axios";
import { Post } from "@/types/post";
import { AJAX_ACTION, NONCE, OPTIONS, POST_TYPES } from "@/utils/constants";
import { useQuery, keepPreviousData } from "@tanstack/react-query";

type QueryParams = {
    post_status?: string;
    id?: number;
    search?: string;
    orderby?: string;
    order?: string;
    limit?: number;
    post_parent?: number | null;
};

export function usePosts(postType = POST_TYPES[0].id, currentPage = 1, queryParams?: QueryParams) {
    const noPagination = currentPage === -1;
    const { id, post_status, search, orderby, order, limit, post_parent } = queryParams || {};

    const query = useQuery<{ posts: Post[]; total: number }>({
        queryKey: ["posts", postType, currentPage, `post_id:${id}`, `post_status:${post_status}`, `search:${search}`, `orderby:${orderby}`, `order:${order}`, `limit:${limit}`, `post_parent:${post_parent}`],
        queryFn: () =>
            ajax({
                action: AJAX_ACTION.GET_POSTS_BY_TYPE,
                nonce: NONCE.GET_POSTS_BY_TYPE,
                post_type: postType,
                limit: noPagination ? -1 : (limit || OPTIONS.PAGINATION_LIMIT),
                offset: noPagination ? 0 : (currentPage - 1) * (limit || OPTIONS.PAGINATION_LIMIT),
                post_id: id,
                post_status,
                search,
                orderby,
                order,
                post_parent: post_parent !== null && post_parent !== undefined ? post_parent : undefined,
            }),
        placeholderData: keepPreviousData,
    });

    return {
        ...query,
        isLoading: query.isLoading || (query.isFetching && query.isPlaceholderData),
    };
}

